<template>
  <v-card class="pa-2 pt-0">
    <v-card-title class="pb-0">{{ title || "Review Count" }}</v-card-title>
    <div class="review-counts mb-1"> <span class="label">Total:</span> {{ reviewCount.total }} </div>
    <div class="review-counts">
      <template v-for="medium in Object.values($mediums)">
        <span :key="medium" class="label">{{ userFriendlyMediumWord(medium) }}: </span>
        {{ reviewCount.perMedium[medium] }}<br :key="medium + 'br'" />
      </template>
    </div>
  </v-card>
</template>

<script>
import { userFriendlyMediumWord } from "../../util/mediumHelpers";

export default {
  name: "review-count",

  props: {
    minDate: Date,
    title: String,
    imports: Boolean,
  },

  data: function () {
    return {
      reviewCount: {
        total: undefined,
        perMedium: {},
      },
    };
  },

  async mounted() {
    this.reviewCount = await this.getReviewCount();
  },

  methods: {
    userFriendlyMediumWord,

    async getReviewCount() {
      let params = {};
      if (this.minDate) {
        params.minDatePosted = this.minDate;
      }
      if (this.imports !== undefined) {
        params.imported = this.imports;
      }

      const response = await this.$axios.get("v1/analytics/review-count", {
        params,
      });
      return response.data;
    },
  },
};
</script>

<style scoped>
.label {
  font-weight: bold;
}
</style>
